import React, {useState, useEffect} from 'react';
import AutoSuggestField from '@FormComponents/AutoSuggestField';
import {injectIntl} from 'react-intl';
import axios from 'axios';
import Joi from '@hapi/joi';
import {dataValidator} from 'dataValidator';
import Button from '../FormComponents/Button';
import Icon from '@Components/Icon';

const SearchForm = ({intl, title, searchParams, baseUrl}) => {
  const [options, setOptions] = useState([]);
  const [url, setUrl] = useState('');
  const [errors, setErrors] = useState({});
  const [state, setState] = useState({
    location: '',
  });
  const locationValidation = {
    location: Joi.string()
        .required()
        .invalid('-1'),
  };
  const validationSchema = Joi.object().keys({
    ...locationValidation,
  });
  validationSchema.errorOverrides = {
    location: {
      'any.required': intl.formatMessage({id: 'SearchForm.Location.Required'}),
      'string.empty': intl.formatMessage({id: 'SearchForm.Location.Required'}),
      'any.invalid': intl.formatMessage({id: 'SearchForm.LocationError'}),
    },
  };
  const changeAutoComplete = (event) => {
    const value = event.target.value;
    setState((prev) => {
      return {
        ...prev,
        location: value,
      };
    });

    getAutocompleteOptions(value);
  };
  const getAutocompleteOptions = (value) => {
    axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
      callback: '@Callbacks/getLocationSuggest',
      currentRoute: {},
      data: {...searchParams, query: value},
    }).then((response) => {
      if (response.data) {
        setOptions(response.data);
      }
    });
  };

  useEffect(() => {
    if (state && state.location) {
      const params = state.location.split(', ');
      setUrl(`${baseUrl}${params[0]?.replace(/ /g, '_')}-${params[1]?.replace(/ /g, '_')}/`);
    }
  }, [state]);

  const onClick = (event) => {
    event.preventDefault();

    let formErrors = dataValidator(state, validationSchema);
    if (formErrors) {
      setErrors(formErrors);
    } else {
      let validLocation = false;
      if (options) {
        options.forEach((item) => {
          if (state.location.toLowerCase() === item.toLowerCase()) {
            validLocation = true;
          }
        });
      }
      if (!validLocation) {
        formErrors = dataValidator({
          location: '-1',
        }, validationSchema);
        setErrors(formErrors);
      } else {
        setErrors({});
        window.location.replace(url);
      }
    }
  };

  return (
    <>
      <div className="banner cta-banner py-l l:py-xl bg-brand--turquoise text-white">
        <div className="wrapper l:flex justify-between items-center">
          <div className="cta-banner__media">
            <img src="/salary-app/assets/images/pins.svg" width="385px" alt={intl.formatMessage({id: 'Image.Pins.AltText'})}/>
          </div>
          <div className="cta-banner__content content-block">
            <h2 className="content-block__title">
              {intl.formatMessage({id: 'SearchForm.Title'}, {name: title})}
            </h2>
            <p className="content-block__description">
              {intl.formatMessage({id: 'SearchForm.SubTitle'})}
            </p>
            <div className="content-block__form form-groups--row l:mr-l">
              <AutoSuggestField onChange={changeAutoComplete} settings={{
                name: 'location',
                placeholder: 'SearchForm.LocationPlaceholder',
                noResultsMessage: 'SearchForm.Location.NoResults',
                state,
                errors,
                options,
                required: true,
                idName: 'salary-location',
              }} />
              <Button
                className="button button--m button--icon button--filled button--off-white button--full-width-to-icon"
                onClick={onClick}>
                <span className="button__text">{intl.formatMessage({id: 'SearchForm.Button'})}</span>
                <span className="icon" aria-hidden="true">
                  <Icon type="arrow-right-30"/>
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(SearchForm);
